export const CUSTOM_PAYMENT_TERM = 'PERSONALIZADA';
